module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Ruemlingen-92dbeabd25a98467854cc3467b3bb476.png";